import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteMethod, getMethod } from "../../services/ApiCallMethods";

export const getAdvisorDocuments = createAsyncThunk(
  "document/getAdvisorDocuments",
  async (
    {
      advisorId,
      clientId,
      accountType = "",
      account = "",
      timeFrame = "",
      currentPage = 1,
      itemsPerPage = 10,
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();

      if (accountType) params.append("account_type", accountType);
      if (account) params.append("account", account);
      if (timeFrame) params.append("timeframe", timeFrame);
      if (currentPage) params.append("page", currentPage);
      if(clientId) params.append("clientId",clientId);
      if (itemsPerPage) params.append("limit", itemsPerPage);


      // const url = `/advisor/advisorRelatedDocument/${advisorId}?${params.toString()}`;
      const url = `/api/client/${advisorId}/documentsByAdvisorId?${params.toString()}`;

      const response = await getMethod(url);

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);

export const getPropertyByClientId = createAsyncThunk(
  "document/getPropertyByClientId",
  async ({advisorId, docId, search,page }, { rejectWithValue }) => {
    try {
      const { currentPage, itemsPerPage } = page || {};
      const response = await getMethod(
        `/api/documents/getPropertyByDocumentId/${docId}?search=${search}&advisorId=${advisorId}&page=${currentPage}&itemsPerPage=${itemsPerPage}`
      );
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);
export const getInvestorByDocuments = createAsyncThunk(
  "document/getInvestorByDocuments",
  async ({advisorId, docId, search,page }, { rejectWithValue }) => {
    try {
      const { currentPage, itemsPerPage } = page || {};
      const response = await getMethod(
        `/advisor/getInvestorByDocumentId/${docId}?search=${search}&advisorId=${advisorId}&page=${currentPage}&itemsPerPage=${itemsPerPage}`
      );
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);


export const getDocumentsByAccount = createAsyncThunk(
  "documents/getDocumentsByAccountType",
  async ({ name, page,limit,adminClientId, advisorId, accountType, accountCategory, ownerEntity, timeFrame }, { rejectWithValue }) => {
    try {
      // Build query parameters conditionally
      const queryParams = new URLSearchParams();
      // Always inclu  de required parameters
 
      // Conditionally add optional parameters only if they have values
      if (accountType && accountType.trim() !== "") {
        queryParams.append("account_type", encodeURIComponent(accountType));
      }
      if (accountCategory && String(accountCategory).trim() !== "") {
        queryParams.append("account", encodeURIComponent(accountCategory));
      }
      if (timeFrame && timeFrame.trim() !== "") {
        queryParams.append("timeFrame", encodeURIComponent(timeFrame));
      }
      if (advisorId) {
        queryParams.append("advisorId", encodeURIComponent(advisorId));
      }
      if(adminClientId) {
          queryParams.append("clientId", encodeURIComponent(adminClientId));
      }
      if (ownerEntity) {
        queryParams.append("ownerEntity", encodeURIComponent(ownerEntity));
      }
      queryParams.append("page", page);
      
      queryParams.append("limit", limit);

        const response = await getMethod(`/api/getAllDocuments?${queryParams}`);

      // const response = await getMethod(
      //   `/api/client/${adminClientId}/documents?${queryParams.toString()}`
      // );
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);


export const getDocumentbyClients = createAsyncThunk(
  "document/getDocumentbyClients",
  async ({ clientId,advisorId,categories, search,ownerEntity, account_type, account_category, timeframe,page,limit,startDate,endDate }, { rejectWithValue }) => {
    try {
      // Build query parameters dynamically
      const queryParams = new URLSearchParams();

      // Only add parameters that have values
      if (search && search.trim() !== "") {
        queryParams.append("search", search);
      }
       if (page && String(page).trim() !== "") {
        queryParams.append("page", page);
      }

      if (limit && String(limit).trim() !== "") {
        queryParams.append("limit", limit);
      }

      if (clientId && String(clientId).trim() !== "") {
        queryParams.append("clientId", clientId);
      }

      if (account_type && String(account_type).trim() !== "") {
        queryParams.append("account_type", account_type);
      }

      if (account_category && String(account_category).trim() !== "") {
        queryParams.append("account", account_category);
       }
      if (ownerEntity && String(ownerEntity).trim() !== "") {
        queryParams.append("ownerEntity", ownerEntity);
      }

      if (timeframe && timeframe.trim() !== "") {
        queryParams.append("timeframe", timeframe);
      }
      if(advisorId && String(advisorId).trim()!==""){
        queryParams.append("advisorId", advisorId);
      }
      if (Array.isArray(categories) && categories.length > 0) {
        queryParams.append("categoryId", categories.join(","));
      }
      if (startDate) {
        queryParams.append("startDate", startDate);
      }
      if (endDate) {
        queryParams.append("endDate", endDate);
      }
      // Build the URL with query parameters
      const queryString = queryParams.toString();

       const response = await getMethod(`/api/getAllDocuments?${queryString}`);

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);

export const getDocumentbyPropertyId = createAsyncThunk(
  "document/getDocumentbyPropertyId",
  async ({clientId, docId, search,page }, { rejectWithValue }) => {
    try {
      const { currentPage, itemsPerPage } = page || {};
      const response = await getMethod(
        `/api/documents/getPropertyByDocumentId/${docId}?search=${search}&clientId=${clientId}&page=${currentPage}&itemsPerPage=${itemsPerPage}`
      );
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);

export const deleteClientDocument = createAsyncThunk(
  "document/deleteClientDocument",
  async (docId, { rejectWithValue }) => {
    try {
      const response = await deleteMethod(`/api/client/documents/${docId}`);
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to delete document");
    }
  }
);
export const deleteAdvisorDocument = createAsyncThunk(
  "document/deleteAdvisorDocument",
  async (docId, { rejectWithValue }) => {
    try {
      const response = await deleteMethod(
        `/advisor/deleteDocumentUploadedByAdvisor/${docId}`
      );

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || "Unauthorized or failed");
      }

      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Unexpected error");
    }
  }
);
export const getAdvisorsAssociatedToDocument = createAsyncThunk(
  "document/getAdvisorsAssociatedToDocument",
  async ({clientId, docId, search ,page}, { rejectWithValue }) => {
    try {
      const { currentPage, itemsPerPage } = page || {};
      const response = await getMethod(
        `/api/clients/${docId}/getAdvisorsAssociatedToDocument?search=${search}&clientId=${clientId}&page=${currentPage}&itemsPerPage=${itemsPerPage}`
      );
      const data = await response.json();
      return data;
    } catch (error) {

      return rejectWithValue(error?.message || "Failed to fetch documents");
    }
  }
);
export const removeClientDocument = createAsyncThunk(
  "document/removeClientDocument",
  async ({ docId, advId }, { rejectWithValue }) => {
    try {
      const response = await deleteMethod(
        `/api/clients/documents/${docId}/advisors/${advId}/remove`
      );

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || "Unauthorized or failed");
      }

      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Unexpected error");
    }
  }
);
export const removeDocumentPropertyMapping = createAsyncThunk(
  "document/removeDocumentPropertyMapping",
  async (docId, { rejectWithValue }) => {
    try {
      const response = await deleteMethod(
        `/api/clients/${docId}/removeDocumentPropertyMapping`
      );

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || "Unauthorized or failed");
      }

      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Unexpected error");
    }
  }
);
// Initial state
const initialState = {
  advLoading: false,
  error: null,
  advisorDocuments: [],
  advProperties: {},
  pagination: {},
  advDocumentClients: [],
  clientDocuments: [],
  DocumentProperties: {},
  associatedAdvisors: [],
  associatedAdvisorsLoading: false,
  associatedAdvisorsError: null,
  deleteError: null,
  advInvestorPagination:{},
  clientMainPagination:{},
  removePropertyMappingLoading: false,
  removePropertyMappingSuccess: false,
  removePropertyMappingError: null,
  DocumentPropertiespagination:{}
};

// Slice
const advDocumentSlice = createSlice({
  name: "advDocument",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdvisorDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdvisorDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorDocuments = action.payload?.documents || [];
        state.pagination = action.payload?.pagination || {};
      })
      .addCase(getAdvisorDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPropertyByClientId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPropertyByClientId.fulfilled, (state, action) => {
        state.loading = false;
        state.advProperties = action.payload?.data || [];
        state.pagination = action.payload?.pagination || {};
      })
      .addCase(getPropertyByClientId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getInvestorByDocuments.pending, (state) => {
        state.error = null;
        state.advLoading = true;
        state.success = false;
      })
      .addCase(getInvestorByDocuments.fulfilled, (state, action) => {
        state.advLoading = false;
        state.advDocumentClients = action.payload.data || [];
        state.advInvestorPagination =action.payload.pagination||[]
      })

      .addCase(getInvestorByDocuments.rejected, (state, action) => {
        state.advLoading = false;
        state.error = action.payload.message;
      })
      // Client Documents
      .addCase(getDocumentbyClients.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.clientMainPagination={};
      })
      .addCase(getDocumentbyClients.fulfilled, (state, action) => {
        state.loading = false;
        state.clientDocuments = action.payload?.data||[];
         state.clientMainPagination=action.payload?.pagination;
      })
      .addCase(getDocumentbyClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.clientDocuments=[];
        state.clientMainPagination={};
      })
      .addCase(getDocumentbyPropertyId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocumentbyPropertyId.fulfilled, (state, action) => {
        state.loading = false;
        state.DocumentProperties = action.payload?.data || [];
        state.DocumentPropertiespagination=action?.payload?.pagination || [];
      })
      .addCase(getDocumentbyPropertyId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteClientDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClientDocument.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteClientDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAdvisorDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdvisorDocument.fulfilled, (state) => {
        state.loading = false;
        state.deleteError = null;
      })
      .addCase(deleteAdvisorDocument.rejected, (state, action) => {
        state.loading = false;
        state.deleteError = action.payload;
      })
      .addCase(getAdvisorsAssociatedToDocument.pending, (state) => {
        state.associatedAdvisorsLoading = true;
        state.associatedAdvisorsError = null;
      })
      .addCase(getAdvisorsAssociatedToDocument.fulfilled, (state, action) => {
        state.associatedAdvisorsLoading = false;
        state.associatedAdvisors = action.payload?.data || [];
      })
      .addCase(getAdvisorsAssociatedToDocument.rejected, (state, action) => {
        state.associatedAdvisorsLoading = false;
        state.associatedAdvisorsError =
          action.payload || "Failed to fetch advisors";
      })
      .addCase(removeClientDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeClientDocument.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(removeClientDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(removeDocumentPropertyMapping.pending, (state) => {
        state.removePropertyMappingLoading = true;
        state.removePropertyMappingSuccess = false;
        state.removePropertyMappingError = null;
      })
      .addCase(removeDocumentPropertyMapping.fulfilled, (state, action) => {
        state.removePropertyMappingLoading = false;
        state.removePropertyMappingSuccess = true;
        state.removePropertyMappingError = null;
      })
      .addCase(removeDocumentPropertyMapping.rejected, (state, action) => {
        state.removePropertyMappingLoading = false;
        state.removePropertyMappingSuccess = false;
        state.removePropertyMappingError =
          action.payload || "Something went wrong";
      });
  },
});

export default advDocumentSlice.reducer;
